/**
 * @generated SignedSource<<c412e01d955838688a20d45c815853d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateEmailTemplateInput = {
  htmlContent?: string | null | undefined;
  name: string;
  preheader?: string | null | undefined;
  primaryLanguage: string;
  reusable: boolean;
  subject?: string | null | undefined;
  textContent?: string | null | undefined;
};
export type CreateEmailTemplateDialogMutation$variables = {
  input: CreateEmailTemplateInput;
};
export type CreateEmailTemplateDialogMutation$data = {
  readonly createEmailTemplate: {
    readonly id: string;
    readonly name: string;
  };
};
export type CreateEmailTemplateDialogMutation = {
  response: CreateEmailTemplateDialogMutation$data;
  variables: CreateEmailTemplateDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailTemplate",
    "kind": "LinkedField",
    "name": "createEmailTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateEmailTemplateDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateEmailTemplateDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6a0294ed2bbfe40107ad72a1991bf4b2",
    "id": null,
    "metadata": {},
    "name": "CreateEmailTemplateDialogMutation",
    "operationKind": "mutation",
    "text": "mutation CreateEmailTemplateDialogMutation(\n  $input: CreateEmailTemplateInput!\n) {\n  createEmailTemplate(input: $input) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "e96539e16ed2845bc4dbd2de107b6340";

export default node;
